import { Button, Menu, MenuButton, MenuItem, MenuList, Text, Flex } from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import React, { useState } from "react";
import 'services/Recruit/assets/css/panel/style.css';

const CustomDropdown = ({ options, value, onChange }) => {
  const [selectedValue, setSelectedValue] = useState(value || options[0].value);

  return (
    <Menu className="common-label-menu">

      <MenuButton as={Button} rightIcon={<ChevronDownIcon />} w="200px" variant="outline"    className="label" >
        <Text className="label option-label">{options.find((t) => t.value === selectedValue)?.label}</Text>
      </MenuButton>
      <MenuList>
        {options.map((option) => (
          <MenuItem
            className="option-label"
            key={option.value}
            onClick={() => {
              setSelectedValue(option.value);
              onChange && onChange(option.value);
            }}
          >
            {option.label}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};
export default CustomDropdown;
